export default __webpack_public_path__ + "static/media/blog-post-layout-05-img-12.da4d6b05.jpg";